import {
  OverlayScrollbarsComponent,
  OverlayScrollbarsComponentProps,
  OverlayScrollbarsComponentRef,
} from "overlayscrollbars-react";
import "overlayscrollbars/overlayscrollbars.css";
import { forwardRef, PropsWithChildren } from "react";
import "./OverlayScrollbarWrapper.scss";

const OverlayScrollbarWrapper = forwardRef<
  OverlayScrollbarsComponentRef<"div">,
  PropsWithChildren & OverlayScrollbarsComponentProps
>(({ children, ...props }, ref) => {
  return (
    <OverlayScrollbarsComponent
      defer
      {...props}
      ref={ref}
      options={{
        scrollbars: {
          autoHide: "leave",
          theme: "os-theme-dark",
          ...(props.options ? props.options?.scrollbars : {}),
        },
        ...props.options,
      }}
    >
      {children}
    </OverlayScrollbarsComponent>
  );
});

OverlayScrollbarWrapper.displayName = "OverlayScrollbarWrapper";

export default OverlayScrollbarWrapper;
